export enum RoomStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    INACTIVE_PERM = 'INACTIVE_PERM',
    CLOSED = 'CLOSED',
}

export const ROOM_STATUS_CONFIG = {
    [RoomStatus.ACTIVE]: {
        label: 'Available',
        cssClass: 'text-sm !bg-green-100 !text-green-700'
    },
    [RoomStatus.INACTIVE]: {
        label: 'Not available',
        cssClass: 'text-sm !bg-yellow-100 !text-yellow-700'
    },
    [RoomStatus.INACTIVE_PERM]: {
        label: 'Not available - perm',
        cssClass: 'text-sm !bg-red-100 !text-red-700'
    },
    [RoomStatus.CLOSED]: {
        label: 'Not available - historical',
        cssClass: 'text-sm !bg-gray-100 !text-gray-700'
    }
};

// For p-select options - maintains the same structure as before
export const ROOM_STATUS_OPTIONS = Object.entries(ROOM_STATUS_CONFIG).map(([key, value]) => ({
    label: value.label,
    value: key,
    cssClass: value.cssClass
}));
